import { ReactNode, createContext, useContext } from 'react'

interface PreviewModeContextType {
  isPreviewMode: boolean
}

const PreviewModeContext = createContext<PreviewModeContextType>({
  isPreviewMode: false,
})

export const usePreviewMode = () => useContext(PreviewModeContext)

interface PreviewModeProviderProps {
  children: ReactNode
}

export const PreviewModeProvider = ({ children }: PreviewModeProviderProps) => {
  return (
    <PreviewModeContext.Provider value={{ isPreviewMode: true }}>
      {children}
    </PreviewModeContext.Provider>
  )
}
